import script from "./Layout.vue?vue&type=script&setup=true&lang=js"
export * from "./Layout.vue?vue&type=script&setup=true&lang=js"

import "./Layout.vue?vue&type=style&index=0&id=324f3b2e&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-324f3b2e"]])

export default __exports__